import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import LoadingSpinner from "components/Common/LoadingSpinner";
import { getFirebaseAuth } from "api/firebase/firebase";
import { ROUTES } from "./AppConfig";

/**
 * The multicriteria (suitability) route. Only for signed-in, non-anonymous
 * users of a customization with the `suitabilityMapping` flag.
 *
 * On a reload or a bookmark, Firebase restores the session asynchronously:
 * `currentUser` is null until then, and the config may still be loading. The
 * decision waits for both, or the deep link would redirect home at once. The
 * store's `loading` flag can't be used here: only the Login screen's auth
 * listener resolves it, and Login is not mounted on this route.
 */
function SuitabilityRoute({ config, component: Component }) {
  const [authRestored, setAuthRestored] = useState(false);

  useEffect(() => {
    let active = true;
    const markRestored = () => {
      if (active) setAuthRestored(true);
    };
    getFirebaseAuth().authStateReady().then(markRestored, markRestored);
    return () => {
      active = false;
    };
  }, []);

  if (!authRestored || config === null) {
    return <LoadingSpinner />;
  }

  const firebaseUser = getFirebaseAuth().currentUser;
  if (
    config?.featureFlags?.suitabilityMapping &&
    firebaseUser &&
    firebaseUser.isAnonymous === false
  ) {
    return <Component />;
  }
  return <Redirect to={ROUTES.ROOT} />;
}

SuitabilityRoute.propTypes = {
  config: PropTypes.object,
  component: PropTypes.elementType.isRequired,
};

export default SuitabilityRoute;
